import api from "./api";
import jwt_decode from "jwt-decode";
import { JWTToken } from "../routes/privateRoute";

export default class PaymentApiNovo {
  static postPaymentSolicitation = async (obj: any, code: any) => {
    const token = window.localStorage.getItem("token");
    let manualParam = "";

    if (token) {
      try {
        const decoded: JWTToken = jwt_decode(token);
        if (decoded.loginPermissoes) {
          const loginPermissoes: number[] = JSON.parse(decoded.loginPermissoes);
          if (loginPermissoes.includes(41)) {
            manualParam = "?manual=true";
          }
        }
      } catch (error) {}
    }

    const response = await api.post(`/PagamentoNovo${manualParam}`, obj, {
      headers: {
        codigo: code || "",
      },
    });

    return response.data;
  };

  static confirmPayment = async (id: number, code: string, valor: number) => {
    const body = {
      codigo: code,
      valor: valor,
    };
    const response = await api.post(`/PagamentoNovo/${id}/Confirmar`, body);
    return response.data;
  };

  static deletePaymentPerId = async (id: number) => {
    const response = await api.delete(`/PagamentoNovo/${id}`);
    return response.data;
  };

  static getPaymentSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    minValue: any,
    maxValue: any,
    manual: boolean = false
  ) => {
    const manualParam = manual ? "&manual=true" : "";
    const response = await api.get(
      `/PagamentoNovo?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${minValue}&valorFim=${maxValue}${manualParam}`
    );
    return response;
  };

  static getPaymentPerId = async (idPayment: any) => {
    const response = await api.get(`/PagamentoNovo/${idPayment}`);
    return response.data;
  };

  static exportPayment = async (
    idStatus: any,
    valorInicio: any,
    valorFim: any,
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string
  ) => {
    const response = await api.get(
      `/PagamentoNovo/exportacao/download?idStatus=${idStatus}&idCliente=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}&valorInicio=${valorInicio}&valorFim=${valorFim}&Search=${search}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
